/*
* ***********************************Example of Usage***********************************
*
* 1 - Simple usage
*    <KeyNavigator focusIndex={1}
*                  list={[{id: 1, name: "I1"}, {id: 2, name: "I2"}]}
*                  onNavigate={myFunction}>
*      <input/>
*    </KeyNavigator>
*
* 2 - When enabling "enter" and "esc" keys to execute a function
*      **(esc will always send "false" as second parameter as it should always "undo" state)
*    <KeyNavigator focusIndex={1}
*                  list={[{id: 1, name: "I1"}, {id: 2, name: "I2"}]}
*                  onNavigate={myFunction}
*                  onEnterPressed={this.myEnterFunction}
*                  onEscPressed={this.myEscFunction}>
*      <input/>
*    </KeyNavigator>
*/

"use strict";

var _ = require("underscore");
var navigateKeys = {
  UP: 38,
  DOWN: 40,
  ENTER: 13,
  ESC: 27,
  ALL_KEYS: [38, 40, 13, 27]
};

var KeyNavigator = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    children: React.PropTypes.node.isRequired,
    focusIndex: React.PropTypes.number.isRequired,
    onNavigate: React.PropTypes.func.isRequired,
    onEnterPressed: React.PropTypes.func,
    onEscPressed: React.PropTypes.func,
    list: React.PropTypes.oneOfType([
      React.PropTypes.arrayOf(React.PropTypes.object),
      React.PropTypes.array
    ])
  },
  getInitialState: function() {
    return ({list: []});
  },
  handleKeyDown: function(e){
    if(navigateKeys.ALL_KEYS.indexOf(e.keyCode) != -1){
      this.keyNavigate(e.keyCode, this.props.list);
    }
  },
  keyNavigate: function(keyCode, list) {
    if (keyCode == navigateKeys.DOWN) {
      this.navigateDown(list);
    } else if (keyCode == navigateKeys.UP) {
      this.navigateUp(list);
    } else if (keyCode == navigateKeys.ENTER) {
      this.enterPressed(list);
    } else if (keyCode == navigateKeys.ESC) {
      this.escPressed(list);
    }
  },
  navigateDown: function(list) {
    var focusIndex = this.props.focusIndex;
    if(list.length > 0) {
      if (focusIndex + 1 >= list.length) {
        focusIndex = 0;
      } else {
        focusIndex++;
      }
      this.props.onNavigate(focusIndex, list[focusIndex]);
    }
  },
  navigateUp: function(list) {
    var focusIndex = this.props.focusIndex;
    if(list.length > 0) {
      if (focusIndex - 1 <= -1) {
        focusIndex = list.length-1;
      } else {
        focusIndex--;
      }
      this.props.onNavigate(focusIndex, list[focusIndex]);
    }
  },
  enterPressed: function(list) {
    if(this.canCallSelection(list, this.props.onEnterPressed)) {
      this.props.onEnterPressed(list[this.props.focusIndex]);
    }
  },
  escPressed: function(list) {
    if(this.canCallSelection(list, this.props.onEscPressed)) {
      this.props.onEscPressed(list[this.props.focusIndex], false);
    }
  },
  getKeyWatcherElement: function() {
    var keyWatcherElement = this.props.children;
    var extraProps = {
      onKeyDown: this.handleKeyDown
    };
    return React.cloneElement(keyWatcherElement, extraProps);
  },
  canCallSelection: function(list, callback) {
    var callbackIsFunction = (typeof callback === "function");

    var index = this.props.focusIndex;
    var indexInListBoundaries = (index >= 0 && index < list.length);

    return (callbackIsFunction && indexInListBoundaries);
  },
  render: function() {
    return (this.getKeyWatcherElement());
  }
});


module.exports = KeyNavigator;



// WEBPACK FOOTER //
// ./app/shared/components/KeyNavigator/key-navigator.jsx